import React from "react";

export default function CalendarDropdown({ months }) {
  return (
    <div className="tc--sb--calendar" onClick={(e) => e.stopPropagation()}>
      <div className="tc--calendar--head">
        <div className="tc--left--cal--head">
          <ul className="tc--dep--ret--selection">
            <li className="tc--selected--head">
              <img src="https://tripprizer.com/static/media/frame-203.1eabd35779cb3fb7320e.svg" alt="calendar" />
              30 Jan, 2026
            </li>
            <li>
              <img src="https://tripprizer.com/static/media/calendar.345e06143bc9d675a3c4.svg" alt="calendar" />
              Add Return to Save more
            </li>
          </ul>
        </div>
        <div className="tc--right--cal--head">
          Number of Days <input type="text" value="22" disabled />
        </div>
      </div>

      <div className="tc--calendar--content">
        <div className="tc--calendar--wrapper">
          <div className="tc--calendar--header">
            <img src="https://tripprizer.com/static/media/arrow-9.d00da81a44e0f3e90ae1.svg" alt="prev" className="tc--previous--month" />
            <div className="tc--cal--month--header active--tc--cal--month">
              September 2026 <img src="https://tripprizer.com/static/media/arrow-10.876700a6999b736803e1.svg" alt="arrow" />  
              <ul className="tc--monthlist--dropdown">
                {months.map((month, idx) => <li key={idx}>{month}</li>)}
              </ul>
            </div>
          </div>
          <div className="tc--days--name">
            <ul className="tc--daysname--grid">
              {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map(d => <li key={d}>{d}</li>)}
            </ul>
          </div>
          <div className="tc--caldays--data">
            <ul className="tc-caldays-grid">
              <li className="tc--null"></li><li className="tc--null"></li><li className="tc--null"></li>
              {[...Array(30)].map((_, i) => (
                <li key={i} className={i === 13 ? "tc--active--selected" : "tc--nonactive--date"}>
                  <div className="tc--caldate">{i + 1}</div>
                  <div className="tc--caldate--price">{i > 10 ? "10,00,000" : ""}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}